import React from 'react';

interface BookSelectorHeroProps {
  // No props needed - removed directory selection
}

const BookSelectorHero: React.FC<BookSelectorHeroProps> = () => {
  return (
    <div className="book-selector-hero">
      <div className="hero-content">
        <div className="hero-icon">
          📚
        </div>
        
        <h1 className="hero-title">
          Welcome to Book CMS
        </h1>
        
        <p className="hero-subtitle">
          Use the directory selector in the header to add your books directory and get started.
        </p>
        
        <div className="hero-help">
          <p className="help-text">
            <strong>Getting Started:</strong> Click the directory selector in the header above
          </p>
          <p className="help-subtext">
            The system will automatically find your book list file (all-books.json, books.json, etc.) and scan for book folders
          </p>
        </div>
      </div>
    </div>
  );
};

export default BookSelectorHero;
